// extracted by mini-css-extract-plugin
export default {"root":"_1boF2","input":"_15gMW"};